// import {ViewModelProvider} from './ViewModelContext';

const IdvResubmitContent = () => {
  return <>Resubmit</>;
};

const IdvResubmitPage = () => (
  //   <ViewModelProvider>
  <IdvResubmitContent />
  //   </ViewModelProvider>
);

export default IdvResubmitPage;
